import { Component, Input } from '@angular/core';

// Reusable skeleton-loading placeholder for migrated Angular components/modals.
// Replaces the legacy `fa-spinner fa-spin` "Loading" text pattern - see
// blueprint/page-migration-plan.md, "Loading state: skeletons, not spinners".
@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.css']
})
export class SkeletonLoaderComponent {

  // 'lines' - stacked text-line bars (default, for text/paragraph content)
  // 'form' - label+input row pairs (for form-shaped panes)
  // 'block' - a single rectangular placeholder (for tables/cards/images)
  @Input() variant: 'lines' | 'form' | 'block' = 'lines';
  @Input() rows = 3;

  rowsArray(): number[] {
    return Array(this.rows).fill(0);
  }
}
